import axios from '../axios';

export const show = (lang) => {
  return axios.get(`/about-us-homepage-section?lang=${lang}`);
};

export const submit = (payload) => {
  return axios.post('/about-us-homepage-section', payload);
};
